"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groceryCategoryInfoFragment = void 0;
const client_1 = require("@apollo/client");
exports.groceryCategoryInfoFragment = client_1.gql `
  fragment GroceryCategoryInfo on GroceryCategory {
    __typename
    id
    name
    position
  }
`;
//# sourceMappingURL=groceryCategory.js.map